import React, { Component, Fragment, useState } from 'react';
import { Button, Space, Swiper, Toast, ImageViewer, Slider } from 'antd-mobile'
import { SwiperRef } from 'antd-mobile/es/components/swiper'
import { poiDetail } from '../../api/index';
import { formatSeconds } from '../../utils/utils'
import moduleCss from "./index.module.scss";
const colors = ['#ace0ff', '#bcffbd', '#e4fabd', '#ffcfac']
// const detailInfo = { "id": 19, "name": "测试景点", "desc": "这是一个测试景点这是一个测试景点这是一个测试景点这是一个测试景点这是一个测试景点这是一个测试景点这是一个测试景点这是一个测试景点这是一个测试景点这是一个测试景点这是一个测试景点", "banner": "https://cdnbudao.yunjinginc.com/media/budao_content/files/9ab3221ba71e30ac33717234ac4ca95642be419c.png", "video": "https://cdnbudao.yunjinginc.com/media/budao_content/files/08906cc64d2458fc41dc1b6a6a67999f20a84fc5.mp4", "audio": "https://cdnbudao.yunjinginc.com/media/budao_content/files/98202930af652750cf42cb94f1425b0b0e79b383.mp3", "extra": "{\"imgArr\":[{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/9ab3221ba71e30ac33717234ac4ca95642be419c.png\"},{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/b8c8c2b925a2d26ef607e90df1655ec39504e0c9.png\"},{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/53f00fb512e98e5a77dc0f39ff15cab10da664c7.png\"},{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/2d984bf400b6e5bd706f75d55b78e970f6ca626e.png\"},{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/3105a8661d377f368a8a470b12ae8244837ac6f3.png\"},{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/ba10e23053de3e04a36977b9678f25de8a27deea.png\"},{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/01d731cbe724a180babbbeab84641d8fc6af8ee4.png\"},{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/f0bd12fd9e354ba54c2f7bd3c1dab02dd7a614f0.png\"},{\"url\":\"https://cdnbudao.yunjinginc.com/media/budao_content/files/fb9a605a38073a2875c672280ff280fb04998ea2.png\"}],\"video_duration\":10,\"audio_duration\":64}", "act_type": 1, "area_info": null, "gps": [108.98451100935213, 34.2351622960513] }


let imgPreview = []


const showPrview = (idx) => {
  const props = { images: imgPreview, defaultIndex: idx }
  ImageViewer.Multi.show(props)
}

// const bindChangeSlider = (e) => {
//   console.log(e)
// }

const bindChangeSlider = (value) => {
  let text = ''
  if (typeof value === 'number') {
    text = `${value}`
  } else {
    text = `[${value.join(',')}]`
  }
  //Toast.show(`当前选中值为：${text}`)
  console.log(value)
}


const PrviewSec = ({ detailInfo }) => {
  const [visible, setVisible] = useState(false)
  if (!detailInfo.id) return null

  let pic = []
  const imgArr = JSON.parse(detailInfo.extra).imgArr
  const imgItem = imgArr.map((item, index) => {
    pic.push(item.url)
    return <img className={moduleCss.img} src={item.url} alt="" key={index} onClick={() => { showPrview(index) }} />
  });
  imgPreview = pic
  return (
    <>
      {imgItem}
      {/* <ImageViewer.Multi
        images={imgPreview}
        visible={visible}
        defaultIndex={0}
        onClose={() => {
          setVisible(false)
        }}
      /> */}
    </>
  )

}

class Detail extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(this.props.location.search);
    this.state = {
      list: [],
      type: params.get("type"),
      id: params.get("id"),
      detailInfo: {},
      isPlayVideo: false,
      isPlayAudio: false,
      audioDur: 0,
      videoDur: 0,
      leftBar: 0,
      audioNow: 0
    };
  }
  async componentDidMount() {

    await this.getPoiDetail(this.state.id);
    this.audioDeal()
  }
  async getPoiDetail(id) {

    await poiDetail(id).then(res => {
      const extra = res.extra ? JSON.parse(res.extra) : { video_duration: 0, audio_duration: 0 }
      this.setState({
        detailInfo: res,
        videoDur: extra.video_duration,
        audioDur: extra.audio_duration
      });
    })
  }

  audioDeal = () => {
    const audio = document.getElementById("audio")
    audio.addEventListener("timeupdate", (e) => {
      console.log(audio.currentTime, audio.duration)
      const leftBar = parseInt(audio.currentTime / audio.duration * 100)
      console.log(leftBar)
      this.setState({
        leftBar,
        audioNow: parseInt(audio.currentTime)
      });
    })
    audio.addEventListener('ended', () => {
      this.setState({
        leftBar: 0,
        audioNow: 0
      });
      this.setState({
        isPlayAudio: false,
      });
    })
  }

  videoDeal = () => {
    const video = document.getElementById('video')
    video.addEventListener('ended', () => {
      // this.setState({
      //   leftBar: 0,
      //   audioNow: 0
      // });
      this.setState({
        isPlayVideo: false,
      });
    })
  }

  bindPlayAudio = () => {
    const audio = document.getElementById("audio")
    if (!this.state.isPlayAudio) {
      audio.play()
      this.setState({
        isPlayAudio: true,
      });
    } else {
      audio.pause()
      this.setState({
        isPlayAudio: false,
      });
    }

  }

  bindPlayVideo = () => {
    this.setState(
      {
        isPlayVideo: true
      }, () => {
        document.getElementById('video').play()
        this.videoDeal()
      }
    );
  }
  bindOnChange = (value) => {
    this.setState({
      leftBar: value
    })
    const audio = document.getElementById("audio")
    audio.currentTime = audio.duration * (value / 100)
  }
  AudioBox = (isPlayAudio, dur, bindPlayAudio, leftBar, audioNow) => {
    const showDur = formatSeconds(dur)
    const showAudioNow = formatSeconds(audioNow)
    return (
      <div className={moduleCss.audioArea}>
        <div className={isPlayAudio ? moduleCss.audioLineActive : moduleCss.audioLine}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span className={moduleCss.dur}>{showAudioNow}</span>
        <div className={moduleCss.sliderBox}>
          <Slider className={moduleCss.sliderStyle} onAfterChange={bindChangeSlider} value={leftBar} onChange={this.bindOnChange} />

        </div>
        <span className={moduleCss.dur}>{showDur}</span>
        <i className={isPlayAudio ? moduleCss.iAudioPause : moduleCss.iAudioPlay} onClick={() => {
          bindPlayAudio()
        }}></i>
      </div>
    )
  }

  render() {
    const { list, isPlayVideo, isPlayAudio, detailInfo, audioDur, videoDur, leftBar, audioNow, type } = this.state;
    return (
      <div>
        <div className={moduleCss.topBox}>
          {
            detailInfo.video
              ?
              isPlayVideo
                ?
                <video id="video" controls className={moduleCss.pic} src={detailInfo.video}></video>
                :
                <div className={moduleCss.posterBox}>
                  <img className={moduleCss.pic} src={detailInfo.banner}></img>
                  <div className={moduleCss.videoShadow}>
                    <i className={moduleCss.iPlay} onClick={() => {
                      this.bindPlayVideo()
                    }}></i>
                    <span className={moduleCss.videoDur}>{formatSeconds(videoDur)}</span>
                  </div>
                </div>
              :
              <img className={moduleCss.pic} src={detailInfo.banner}></img>
          }
        </div>
        {
          detailInfo.extra ?
            <div className={moduleCss.picBox}>
              <h1 className={moduleCss.title}>精选内容</h1>
              <div className={moduleCss.imgCtnr}>
                {
                  detailInfo.video ?
                    <div className={moduleCss.videoItem}>
                      <img className={`${moduleCss.img} ${moduleCss.imgActive}`} src={detailInfo.banner} alt="" />
                      <i className={moduleCss.iVideo}></i>
                    </div>
                    : null
                }
                <PrviewSec detailInfo={detailInfo} />
              </div>
            </div>
            : null
        }
        <div className={moduleCss.scenicDesp}>
          <h1 className={moduleCss.title}>{type == 2 ? '陈列' : '遗址'}介绍</h1>
          {
            detailInfo.audio ?
              this.AudioBox(isPlayAudio, audioDur, this.bindPlayAudio, leftBar, audioNow)
              : null
          }
          <p className={moduleCss.desc}>{detailInfo.desc}</p>
        </div>
        <audio id="audio" src={detailInfo.audio}></audio>
      </div>
    )
  }
}
export default Detail